<div class="outer-container">
  <h6 class="page-title">
    {{ title }}
    <span class="title-line"></span>
  </h6>

  <mat-card class="custom-card" *ngIf="currentSlide === 1">
    <mat-card-header>
      <mat-card-title>How would you like your report?</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-radio-group
        aria-label="Select an option"
        [(ngModel)]="selectedReportOption"
        (change)="onReportRadioSelect($event)"
      >
        <mat-radio-button value="Full Report"
          ><span style="text-transform: none; font-weight: 500">Full Report</span></mat-radio-button
        >
        <mat-radio-button value="Partial Report"
          ><span style="text-transform: none; font-weight: 500">Partial Report</span></mat-radio-button
        >
        <mat-radio-button value="Report using Order #"
          ><span style="text-transform: none; font-weight: 500">Report using Order #</span></mat-radio-button
        >
      </mat-radio-group>

      <!-- Order Number Input Section -->
      <div
        *ngIf="selectedReportOption === 'Report using Order #'"
        style="margin-top: 16px; margin-left: 32px; width: 220px"
      >
        <form [formGroup]="orderNumberForm" autocomplete="off">
          <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
            <mat-label>Order Number</mat-label>
              <input
                id="orderNumber"
                placeholder="Enter Order Number"
                formControlName="orderNumber"
                (focus)="focusOn('orderNumber')"
                (focusout)="focusOn('orderNumber')"
                autocomplete="no"
                cdkFocusInitial
                matInput
                aria-describedby="orderNumber"
                autofocus
                (input)="checkOrderNumberInput()"
                style="width: 100%"
              />
          </mat-form-field>
        </form>
      </div>
    </mat-card-content>
  </mat-card>

  <div *ngIf="currentSlide === 2" class="full-width">
    <div class="partial-report-section">
      <div
        class="custom lrg padding lrg right bottom left"
        title="Enter individual keys separated by a comma or the star symbol before any master symbol for maison, ex *GGM or *AA
      or *AB"
      >
        Enter individual keys separated by a comma or the star symbol before any master symbol for maison, ex *GGM or
        *AA or *AB
      </div>

      <form [formGroup]="keySetSymbolsForm" autocompete="off">
        <div class="row center">
          <!-- Key Name -->
          <mat-form-field floatLabel="always" appearance="outline" class="padding sm right left full-width">
            <mat-label>Key Name(s)</mat-label>
              <input
                class="uppercase"
                id="keySetSymbols"
                placeholder="Enter Key Name/s"
                formControlName="keySetSymbols"
                (focus)="focusOn('keySetSymbols')"
                (focusout)="focusOn('keySetSymbols')"
                autocomplete="no"
                cdkFocusInitial
                matInput
                aria-describedby="keySetSymbols"
                autofocus
                (input)="checkSymbolsInput()"
              />
          </mat-form-field>

          <div class="center">
            <button
              class="small-icon-button add-button-to-report"
              mat-fab
              color="primary"
              [disabled]="!isSymbolsButtonEnabled"
              (click)="addKeySetSymbols()"
            >
              <mat-icon fontSet="material-icons-outlined" class="white">add</mat-icon>
            </button>
            <span class="center-label">Add to report</span>
          </div>

        </div>
      </form>
      <div>
        <form [formGroup]="thruNotationForm" autocompete="off">
          <div class="custom lrg padding lrg right bottom left">AND/OR Enter groups of keys by range</div>
          <div class="row center">
            <!-- Prefix -->
            <mat-form-field floatLabel="always" appearance="outline" class="padding sm right left">
              <mat-label>Prefix</mat-label>
                <input
                  class="uppercase"
                  id="prefix"
                  placeholder="Enter a Name/Prefix"
                  formControlName="prefix"
                  (focus)="focusOn('prefix')"
                  (focusout)="focusOn('prefix')"
                  autocomplete="no"
                  cdkFocusInitial
                  matInput
                  aria-describedby="Prefix"
                />
            </mat-form-field>

            <!-- From -->
            <mat-form-field floatLabel="always" appearance="outline" class="padding sm right left">
              <mat-label>From</mat-label>
                <input
                  class="uppercase"
                  id="from"
                  placeholder="Enter From Value"
                  formControlName="from"
                  (focus)="focusOn('from')"
                  (focusout)="focusOn('from')"
                  autocomplete="no"
                  cdkFocusInitial
                  matInput
                  aria-describedby="From"
                  (input)="checkRangeInput()"
                  (paste)="handleContextMenuInput()"
                  (contextmenu)="handleContextMenuInput()"
                  (change)="handleContextMenuInput()"
                />
            </mat-form-field>

            <!-- To -->
            <mat-form-field floatLabel="always" appearance="outline" class="padding sm right left">
              <mat-label>To</mat-label>
                <input
                  class="uppercase"
                  id="to"
                  placeholder="Enter To Value"
                  formControlName="to"
                  (focus)="focusOn('to')"
                  (focusout)="focusOn('to')"
                  autocomplete="no"
                  cdkFocusInitial
                  matInput
                  aria-describedby="To"
                  (input)="checkRangeInput()"
                  (paste)="handleContextMenuInput()"
                  (contextmenu)="handleContextMenuInput()"
                  (change)="handleContextMenuInput()"
                />
            </mat-form-field>
            <!-- Suffix -->
            <mat-form-field floatLabel="always" appearance="outline" class="padding sm right left">
              <mat-label>Suffix</mat-label>
                <input
                  class="uppercase"
                  id="suffix"
                  placeholder="Enter a Suffix"
                  formControlName="suffix"
                  (focus)="focusOn('suffix')"
                  (focusout)="focusOn('suffix')"
                  autocomplete="no"
                  cdkFocusInitial
                  matInput
                  aria-describedby="Suffix"
                />
            </mat-form-field>
            <div class="center">
              <button
                class="small-icon-button add-button-to-report"
                mat-fab
                color="primary"
                [disabled]="!isRangeButtonEnabled"
                (click)="addRange()"
              >
                <mat-icon fontSet="material-icons-outlined" class="white">add</mat-icon>
              </button>
              <span class="center-label">Add to report</span>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Symbol Selections Section -->
    <mat-card class="symbol-selections-card" *ngIf="symbols.length > 0">
      <div class="report-selections-title">Symbol Selections</div>
      <!-- Material Chips -->
      <mat-chip-list aria-label="Report Selections">
        <mat-chip *ngFor="let symbol of symbols" removable (removed)="removeSymbol(symbol)">
          {{ symbol }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </mat-card>

    <!-- Range Selections Section -->
    <mat-card class="range-selections-card" *ngIf="ranges.length > 0">
      <div class="report-selections-title">Range Selections</div>
      <mat-chip-list aria-label="Range Selections">
        <mat-chip *ngFor="let range of ranges" removable (removed)="removeRange(range)">
          {{ range }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </mat-card>
  </div>

  <div class="button-container">
    <button mat-raised-button class="cancel-button" (click)="cancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="currentSlide === 1 && selectedReportOption === 'Partial Report'"
      (click)="goToNextSlide()"
    >
      Next
    </button>
    <button mat-raised-button class="back-button" *ngIf="currentSlide === 2" (click)="goToPreviousSlide()">Back</button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="
        selectedReportOption === 'Full Report' || selectedReportOption === 'Report using Order #' || currentSlide === 2
      "
      (click)="submitReportRequest()"
      [disabled]="EnableDisableGenerateReportButton()"
    >
      Generate Report
    </button>
  </div>
</div>